export default "__VITE_ASSET__aca014da__"